import api from '@/utils/api'

export default {
  state: () => ({
    socialsList: null,
  }),
  mutations: {
    setSocialsList(state, payload) {
      state.socialsList = payload
    },
  },
  getters: {},
  actions: {
    async fetchSocialsList({ commit }) {
      const res = await api.http.get('admin/social-networks')
      commit('setSocialsList', res?.data?.data)
      return res?.data?.data
    },

    async createSocial(_, formData) {
      await api.http.post('admin/social-networks', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },

    async updateSocial(_, {formData, id}) {
      await api.http.post(`admin/social-networks/${id}/update`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },

    async deleteSocial(_, id) {
      await api.http.delete(`admin/social-networks/${id}/delete`)
    },

    async getSocial(_, id) {
      const res = await api.http.get(`admin/social-networks/${id}`)
      return res?.data?.data
    },

    async uploadImage(_, formData) {
      const res = await api.http.post('admin/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return res?.data?.data
    },
  },
  namespaced: true,
}
